<template>
  <v-dialog
    :value="handler"
    hide-overlay
    scrollable
    transition="dialog-bottom-transition"
    class="elevation-5"
    persistent
  >
    <v-card>
      <v-card-title class="elevation-5" style="position: relative; z-index: 999;">
        <v-spacer></v-spacer>
        <p>Termos e condições</p>
        <v-spacer></v-spacer>
        <v-btn small fab class="elevation-0" @click="$emit('request-close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text style="height: 80vh;">
        <v-container fluid class="py-10">
          <v-row no-gutters>
            <!-- <v-spacer></v-spacer> -->
            <v-col cols="12">
              <div class="d-flex align-center mb-4 justify-center">
                <v-btn color="primary" @click="paginaAnterior">Anterior</v-btn>
                <span class="mx-4">{{ contadorPaginas }}</span>
                <v-btn color="primary" @click="proximaPagina">Próximo</v-btn>
              </div>
              <pdf
                :src="enderecoTermosCondicoes"
                :page="currentPage"
                @numpages="pageCount = $event"
              >
                <template slot="loading">
                  <div class="text-center">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    />
                  </div>
                </template>
              </pdf>
              <div class="d-flex align-center mt-4 justify-center">
                <v-btn color="primary" @click="paginaAnterior">Anterior</v-btn>
                <span class="mx-4">{{ contadorPaginas }}</span>
                <v-btn color="primary" @click="proximaPagina">Próximo</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import pdf from 'pdfvuer';

export default {
  name: 'VTermsDialog',
  components: {
    pdf,
  },
  props: {
    handler: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      pageCount: 1,
      usuarioLeuTermos: false,
    };
  },
  computed: {
    enderecoTermosCondicoes() {
      return `${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1/autenticacao/termos-condicoes`;
    },
    usuarioLendoUltimaPagina() {
      return this.pageCount && this.currentPage === this.pageCount;
    },
    contadorPaginas() {
      if (this.pageCount !== undefined) {
        return `Página ${this.currentPage} / ${this.pageCount}`;
      }
      return 'Aguarde...';
    },
  },
  methods: {
    paginaAnterior() {
      if (!this.pageCount) {
        this.currentPage = 1;
      } else if (this.currentPage === 1) {
        this.currentPage = 1;
      } else {
        this.currentPage -= 1;
      }
    },
    proximaPagina() {
      if (!this.pageCount) {
        this.currentPage = 1;
      } else if (this.currentPage === this.pageCount) {
        this.currentPage = this.pageCount;
      } else {
        this.currentPage += 1;
      }
    },
  },
};
</script>

<style>

</style>
